<template>
  <div class="floating-vote-now" v-if="votingLink">
    <a :href="project.voting_link"
       target="_blank"><img src="/static/images/mobile-vote-now.png" alt="Vote Now!"></a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'project',
      'votingLink'
    ])
  }
}
</script>

<style lang="scss">
  .floating-vote-now {
    display: none;
  }

  @media screen and (max-width: 500px) {
    #home {
      .cta-button {
        display: none;
      }
    }

    .floating-vote-now {
      display: block;
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 100;

      img {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/VoteNowFixed.vue